/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 16:12:39
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-09-15 18:16:51
 */

import CryptoJS from 'crypto-js'
import { cryptoKey } from './config'
import store from '@/store'

export const trasfer = (time) => {
  const date = new Date(time.replace(/-/g, '/'))
  const y = date.getFullYear()
  const m = date.getMonth() + 1
  const d = date.getDate()
  const h = date.getHours()
  const mm = date.getMinutes()
  const new_date = `${y}年${m}月${d}日 ${h}:${mm}`
  return new_date
}

const S4 = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

// 生成session_id
export const getSession = () => {
  return (
    `${S4() +
    S4()
    }${
      S4()
    }${
      S4()
    }${
      S4()
    }${
      S4()
    }${S4()
    }${S4()}`
  )
}

export const citys = [
  '北京', '上海', '广州', '深圳', '成都', '杭州', '南京', '天津', '武汉', '重庆', '合肥', '福州', '厦门', '广州', '东莞', '南宁', '贵阳', '兰州', '海口', '郑州', '哈尔滨', '长沙', '石家庄', '苏州', '南昌', '长春', '沈阳', '银川', '呼和浩特', '青岛', '济南', '烟台', '太原', '西安', '昆明', '宁波', '温州'
]

export const RandomNumBoth = (Min, Max) => {
  const Range = Max - Min
  const Rand = Math.random()
  const num = Min + Math.round(Rand * Range) // 四舍五入
  return num
}

export const handlePhone = (phone, isHide) => {
  return `${phone.substr(0, 3)} ${isHide ? '****' : phone.substr(3, 4)} ${phone.substr(7, 4)}`
}

export const headers = (append) => {
  const form = {
    token: store.getters.token,
    timestamp: new Date().getTime(),
    nonce: cryptoKey
  }

  const arr = Object.values(form)
  if (append) {
    const appendKeys = Object.keys(append)
    const appendValues = Object.values(append)
    const appendStr = appendKeys.map((s, i) => { return appendValues[i] ? `${s}${appendValues[i]}` : '' })
    appendStr.sort()
    arr.push(appendStr.join(''))
  }
  arr.sort()
  const str = arr.join('')
  const md5 = CryptoJS.MD5(str).toString()
  for (let i = 0; i < md5.length; i++) {
    md5[i].toLowerCase()
  }
  form.signature = md5
  return form
}
